export const BACKOFFICE_PATH = '/backoffice'
export const ROUTE_PATHS = {
  DASHBOARD: BACKOFFICE_PATH,
  KPI: `${BACKOFFICE_PATH}/applications/:idApplication/prompts/kpi`,
  ERROR: '/error',
  APPLICATION_CREATION: `${BACKOFFICE_PATH}/applications/create`,
  APPLICATION_EDITION: `${BACKOFFICE_PATH}/applications/:idApplication`,
  PROFILES: `${BACKOFFICE_PATH}/profiles`,
  PROFILES_EDIT: `${BACKOFFICE_PATH}/profiles/:idProfile/edit`,
  PROMPT: `${BACKOFFICE_PATH}/applications/:idApplication/prompts/:idPrompt`,
  PROMPT_CREATE: `${BACKOFFICE_PATH}/applications/:idApplication/prompts/create`,
  PROMPT_EDIT: `${BACKOFFICE_PATH}/applications/:idApplication/prompts/:idPrompt/edit`,
  PROMPTS: `${BACKOFFICE_PATH}/applications/:idApplication/prompts`,
  TAG_ADMIN: `${BACKOFFICE_PATH}/tags`,
  IASTART: '/',
  IASTART_APP: '/app/:app',
}
